import {
    User,
    UserBase,
    UserEventsTriggered,
    UserIncomeType,
    UserSignupPurpose,
    UserType,
} from "../../types/user";
import {
    isoStringOrNull,
    sanitizeAvatar,
    unpackDateOrNull,
} from "../dto-helpers";
import { UserSettingsDto } from "./user-settings.dto";

/**
 * Input type for UserDto constructor.
 * Accepts Base type from entity classes.
 */
export type UserDtoInput = UserBase;

export class UserDto {
    static deserialize(dto: UserDto): User {
        return {
            ...dto,
            lastActivity: new Date(dto.lastActivity),
            dateOfBirth: unpackDateOrNull(dto.dateOfBirth),
            settings: UserSettingsDto.deserialize(dto.settings),
            createdAt: new Date(dto.createdAt),
            onboardingCompletedAt: unpackDateOrNull(dto.onboardingCompletedAt),
            eventsTriggered: dto.eventsTriggered,
        };
    }

    id: number;
    name: string;
    legalName: string | null;
    preferredName: string | null;
    email: string | null;
    avatar: string | null;
    firstName: string;
    lastName: string;
    phoneNumber: string | null;
    unverifiedPhoneNumber: string | null;
    phoneNumberDisplay: string | null;
    dateOfBirth: string | null;
    incomeType: UserIncomeType[];
    onboardingComplete: boolean;
    showBookkeepingReviewInvite: boolean;
    bookkeepingReviewScheduled: boolean;
    lastActivity: string;
    iconColor: string;
    savingsCreditLimit: number;
    freeUsageLimit: number;
    settings: UserSettingsDto;
    createdAt: string;
    onboardingCompletedAt: string | null;
    eventsTriggered: UserEventsTriggered | null;
    stripeCustomerId: string | null;
    bookedEnterpriseCall: boolean;
    type: UserType;
    signupPurpose: UserSignupPurpose | null;

    constructor(user: UserDtoInput) {
        this.id = user.id;
        this.name = user.name;
        this.legalName = user.legalName;
        this.preferredName = user.preferredName;
        this.email = user.email;
        this.avatar = sanitizeAvatar(user.avatar);
        this.firstName = user.firstName;
        this.lastName = user.lastName;
        this.phoneNumber = user.phoneNumber;
        this.unverifiedPhoneNumber = user.unverifiedPhoneNumber;
        this.phoneNumberDisplay = user.phoneNumberDisplay;
        this.dateOfBirth = isoStringOrNull(user.dateOfBirth);
        this.incomeType = user.incomeType;
        this.onboardingComplete = user.onboardingComplete;
        this.showBookkeepingReviewInvite = user.showBookkeepingReviewInvite;
        this.bookkeepingReviewScheduled = user.bookkeepingReviewScheduled;
        this.lastActivity = user.lastActivity.toISOString();
        this.iconColor = user.iconColor;
        this.savingsCreditLimit = user.savingsCreditLimit;
        this.freeUsageLimit = user.freeUsageLimit;
        this.settings = new UserSettingsDto(user.settings);
        this.createdAt = user.createdAt.toISOString();
        this.onboardingCompletedAt = isoStringOrNull(
            user.onboardingCompletedAt,
        );
        this.eventsTriggered = user.eventsTriggered;
        this.stripeCustomerId = user.stripeCustomerId;
        this.bookedEnterpriseCall = user.bookedEnterpriseCall;
        this.type = user.type;
        this.signupPurpose = user.signupPurpose;
    }
}
